const PASSWORD_POOL_UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const PASSWORD_POOL_LOWER = 'abcdefghijkmnopqrstuvwxyz';
const PASSWORD_POOL_DIGIT = '0123456789';
const PASSWORD_POOL_SPECIAL = '!@#$%&*';

function randomIntBelow(max: number): number {
  if (max <= 0) return 0;
  const c = globalThis.crypto;
  if (c?.getRandomValues) {
    const buf = new Uint32Array(1);
    c.getRandomValues(buf);
    return buf[0]! % max;
  }
  return Math.floor(Math.random() * max);
}

/**
 * Senha aleatória de 8 caracteres: pelo menos uma maiúscula, minúscula, dígito e caractere especial.
 */
export function generateRandomPassword8(): string {
  const pick = (pool: string) => pool[randomIntBelow(pool.length)]!;
  const required = [
    pick(PASSWORD_POOL_UPPER),
    pick(PASSWORD_POOL_LOWER),
    pick(PASSWORD_POOL_DIGIT),
    pick(PASSWORD_POOL_SPECIAL),
  ];
  const all =
    PASSWORD_POOL_UPPER + PASSWORD_POOL_LOWER + PASSWORD_POOL_DIGIT + PASSWORD_POOL_SPECIAL;
  const chars = [...required];
  for (let i = 0; i < 4; i++) {
    chars.push(pick(all));
  }
  for (let i = chars.length - 1; i > 0; i--) {
    const j = randomIntBelow(i + 1);
    const a = chars[i]!;
    const b = chars[j]!;
    chars[i] = b;
    chars[j] = a;
  }
  return chars.join('');
}
